/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
export { default as BoxLegendSvg } from './BoxLegendSvg';
export { default as LegendSvg } from './LegendSvg';
export { default as LegendSvgItem } from './LegendSvgItem';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nivo/legends/es/svg/index.js
// module id = 1497
// module chunks = 0